import React, { Children } from "react";
import Routess from "./config/Routess";
// import Layout from "./components/Layout"
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  return (
    <div className="App">
     <Routess/>
     {/* <Layout/> */}
    </div>
  );
}

export default App;
